import type { CategoryGuid } from '@atlassian/jira-servicedesk-knowledge-services/src/types';

export const REMOVE_ARTICLE_FROM_CATEGORY_FAILURE =
	'state.actions.remove-article-from-category-failure.REMOVE_ARTICLE_FROM_CATEGORY_FAILURE' as const;

export type RemoveArticleFromCategoryFailurePayload = {
	errorKey: string;
	errorMessage: string;
	statusCode: number;
	articleId: string;
	categoryId: CategoryGuid;
};

export type RemoveArticleFromCategoryFailureAction = {
	type: typeof REMOVE_ARTICLE_FROM_CATEGORY_FAILURE;
	payload: RemoveArticleFromCategoryFailurePayload;
};

export const removeArticleFromCategoryFailure = (
	payload: RemoveArticleFromCategoryFailurePayload,
): RemoveArticleFromCategoryFailureAction => ({
	payload,
	type: REMOVE_ARTICLE_FROM_CATEGORY_FAILURE,
});
